import { call, all, takeLatest, put } from 'redux-saga/effects';
import createFetchFunction from '../utils/create-fetch-func';
import createFetchSagaPattern from '../fetch/fetch-saga-pattern-creator';
import getFetchInstance from './../utils/fetch';
import getDataFromResponse from '../utils/get-data-from-res';
import { fetchCourses } from './course.actions';
import {ICreateCoursePayload} from './course.actions';
function* fetchCoursesAsync() {
    const res = yield getFetchInstance().get('course/all');
    const courses = getDataFromResponse(res);
    yield put(
        fetchCourses({
            courses,
        })
    );
}

function* fetchInsertCourseAsync({
    payload: { data },
}: {
    payload: ICreateCoursePayload;
}) {
    const res = yield getFetchInstance().post('course/insert',data);
    const courses = getDataFromResponse(res);
    
}

function* watchFetchCourses() {
    yield takeLatest(
        createFetchSagaPattern('COURSE'),
        createFetchFunction('COURSE', fetchCoursesAsync),
    );
}

function* watchInsertCourses() {
    yield takeLatest(
        createFetchSagaPattern('CREATE_COURSE'),
        createFetchFunction('CREATE_COURSE',fetchInsertCourseAsync)
    )
}

export default function* courseSagas() {
    yield all([call(watchFetchCourses),call(watchInsertCourses)]);
}
